import React, { useEffect, useState } from "react";
import { InfoOutlined } from "@material-ui/icons";
import pusher from "../../../utils/pusher";
import {
  applyIncidentEvent,
  getProviderIncidents,
  INCIDENTS_CHANNEL,
  INCIDENTS_EVENT,
} from "../../../utils/providerIncidents";
import { Stack, Bar, MessageWrapper } from "./IncidentBanner.style";

// Aviso de caída de un proveedor de mensajería (360dialog / Meta). Lo enciende
// un operador desde la config remota, sin desplegar (IV-007).
//
// Vive en DashboardLayout, así que se ve desde cualquier pantalla autenticada
// —incluido el chat, que es donde está el usuario cuando deja de enviar.
//
// SIN POLLING (revisión de dashboard#192): se lee una vez al montar y a partir
// de ahí los cambios llegan por Pusher. Encuestar cada 60s costaba una petición
// por usuario logueado por minuto de forma permanente —millones al día para leer
// un dato que cambia cada varias semanas— y arrastraba tres problemas más: un
// `console.log` por request en el backend, una query a Mongo por poll, y sobre
// todo el riesgo de que un 401 en el bucle cerrara la sesión de todos.

const PROVIDER_LABELS = {
  "360": "WhatsApp (360dialog)",
  META: "Meta (WhatsApp, Messenger e Instagram)",
};

// Si algún día el backend admite un proveedor nuevo y aquí no se añade, el
// aviso debe seguir leyéndose: mejor el slug crudo que "undefined: ...".
const providerLabel = (provider) => PROVIDER_LABELS[provider] || provider;

const startedAtLabel = (startedAt) => {
  if (!startedAt) return "";
  const date = new Date(startedAt);
  if (Number.isNaN(date.getTime())) return "";
  return ` · desde las ${date.toLocaleTimeString("es-MX", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

const IncidentBanner = () => {
  const [incidents, setIncidents] = useState([]);

  useEffect(() => {
    // React 16 avisa por setState tras desmontar; la petición puede resolver
    // después de que el layout se fue.
    let cancelled = false;

    getProviderIncidents().then((active) => {
      if (!cancelled) setIncidents(active);
    });

    // Canal público y global: el aviso ya es visible para todo el mundo, así que
    // no lleva ningún dato de company ni de usuario.
    const channel = pusher.subscribe(INCIDENTS_CHANNEL);
    channel.bind(INCIDENTS_EVENT, (payload) => {
      if (cancelled) return;
      setIncidents((current) => applyIncidentEvent(current, payload?.incident));
    });

    return () => {
      cancelled = true;
      channel.unbind(INCIDENTS_EVENT);
      pusher.unsubscribe(INCIDENTS_CHANNEL);
    };
  }, []);

  if (!incidents.length) {
    return null;
  }

  return (
    <Stack>
      {incidents.map((incident) => (
        <Bar key={incident.id} type={incident.severity}>
          <MessageWrapper type={incident.severity}>
            <InfoOutlined fontSize="small" />
            {`${providerLabel(incident.provider)}: ${incident.message}${startedAtLabel(
              incident.startedAt
            )}`}
          </MessageWrapper>
        </Bar>
      ))}
    </Stack>
  );
};

export default IncidentBanner;
